export const subAccountsUrl = 'sub-accounts/';
export const subAccountUrl = (subAccountId: string) => `sub-accounts/${subAccountId}/`;
